<template>
  <div class="home">
  
    <Reproductor msg="Profesiones, ocupaciones" audio2="../mp3/PrimariaF/05PF.mp3" cover="../img/6.jpg" name="Primaria F - Lección #5"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
